var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeslider4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1667 20H1.83333C1.57917 20 1.33541 19.8946 1.15569 19.7071C0.975967 19.5196 0.875 19.2652 0.875 19V1C0.875 0.734784 0.975967 0.48043 1.15569 0.292893C1.33541 0.105357 1.57917 0 1.83333 0H17.1667C17.4208 0 17.6646 0.105357 17.8443 0.292893C18.024 0.48043 18.125 0.734784 18.125 1V19C18.125 19.2652 18.024 19.5196 17.8443 19.7071C17.6646 19.8946 17.4208 20 17.1667 20ZM16.2083 18V2H2.79167V18H16.2083ZM4.70833 4H8.54167V8H4.70833V4ZM4.70833 10H14.2917V12H4.70833V10ZM4.70833 14H14.2917V16H4.70833V14ZM10.4583 5H14.2917V7H10.4583V5Z",
    fill: "#8D8DAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeslider4);
export default __webpack_public_path__ + "static/media/homeslider4.763f8058890c8bea50739afb99c86cec.svg";
export { ForwardRef as ReactComponent };